import Crud from "../components/ChecklistCategory/Crud.vue";
import Add from "../components/ChecklistCategory/Add.vue";
import Edit from "../components/ChecklistCategory/Edit.vue";

let routes = {
    path: "/checklist-categories",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/checklist-categories",
            name: "Categorias de Check-List",
            component: Crud
        },
        {
            path: "/checklist-categories/add",
            name: "Nova Categoria",
            component: Add
        },
        {
            path: "/checklist-categories/edit/:id",
            name: "Editar Categoria",
            component: Edit
        }
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/checklist_category.js